"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingBar = void 0;
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var build_svg_icon_1 = require("./build-svg-icon");
var RatingBar_module_css_1 = __importDefault(require("./RatingBar.module.css"));
exports.RatingBar = (0, build_svg_icon_1.buildSvgIcon)(function (props) {
    /* To create the bar percentage we need to create a linearGradient mask
     if the mask id collides with another id, the browser defaults to a no-op
     and doesn't render the bar, thus we need to ensure each maskId is unique
    */
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)('bar-icon-')), 1), randomId = _a[0];
    var barProps = props ? props : {};
    var fillPercentage = typeof barProps.fillPercentage === 'number'
        ? barProps.fillPercentage
        : 100;
    var offsetPercentage = Math.round(fillPercentage * 100);
    var stopColorClassName = barProps.variation === 'secondary'
        ? RatingBar_module_css_1.default.stopColorSecondary
        : RatingBar_module_css_1.default.stopColor;
    var fillClassName;
    if (fillPercentage === 100) {
        fillClassName =
            barProps.variation === 'secondary'
                ? RatingBar_module_css_1.default.fillColorSecondary
                : RatingBar_module_css_1.default.fillColor;
    }
    else if (fillPercentage === 0) {
        fillClassName = RatingBar_module_css_1.default.emptyColor;
    }
    var isValidPercentage = fillPercentage > 0 && fillPercentage < 100;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isValidPercentage && (react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: "offset-".concat(randomId) },
                react_1.default.createElement("stop", { offset: "0%", className: stopColorClassName }),
                react_1.default.createElement("stop", { offset: "".concat(offsetPercentage, "%"), className: stopColorClassName }),
                react_1.default.createElement("stop", { offset: "".concat(offsetPercentage, "%"), className: RatingBar_module_css_1.default.stopColorEmpty }),
                react_1.default.createElement("stop", { offset: "100%", className: RatingBar_module_css_1.default.stopColorEmpty })))),
        react_1.default.createElement("rect", { x: "0.459717", y: "0.5", width: "29.4167", height: "5", className: fillClassName, fill: fillClassName === undefined ? "url(#offset-".concat(randomId, ")") : undefined })));
}, 'RatingBar', { viewBox: '0 0 30 6' });
exports.default = exports.RatingBar;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/RatingBar.js
// module id = 3634
// module chunks = 25